export default "__VITE_ASSET___ZgK_2kt__"